import moment from 'moment';

export default class DateTime {

    public static formats = {
        date: 'L',
        dateTime: 'L LT',
        time: 'LT'
    };

    public static getLocale(): string {
        return moment.locale();
    }

    public static setLocale(locale: string): string {
       return moment.locale(locale);
    }

    public static toUtc(localDateTime: number | string | void | Date | moment.Moment | moment.MomentInputObject | (string | number)[] | undefined, format: string) {
        if (!localDateTime) {
            return undefined;
        }

        localDateTime = DateTime.convertToDateIfStringEndsWithZ(localDateTime);

        return moment(localDateTime, format).utc();
    }

    public static toUtcString(localDateTime: number | string | void | Date | moment.Moment | moment.MomentInputObject | (string | number)[] | undefined, format: string) {
        const m = DateTime.toUtc(localDateTime, format);
        if (m == null) return undefined;
        return m.format();
    }

    public static toLocal(utcDateTime: number | string | void | Date | moment.Moment | moment.MomentInputObject | (string | number)[] | undefined, format: string) {
        if (!utcDateTime) {
            return undefined;
        }

        utcDateTime = DateTime.convertToDateIfStringEndsWithZ(utcDateTime);

        return moment.utc(utcDateTime, format).local();
    }

    public static toLocalString(utcDateTime: number | string | void | Date | moment.Moment | moment.MomentInputObject | (string | number)[] | undefined, format: string) {
        const localeData = moment.localeData();
        format = localeData.longDateFormat('L');
        const m = DateTime.toLocal(utcDateTime, format);
        if (m == null) return undefined;
        return m.format(format);
    }

    public static localDateTime(dateTime: string | null, format: string | undefined) {

        if (!dateTime) {
            return undefined;
        }

        return moment(dateTime).format(format);
    }

    public static getCurrentDateTime(format?: string) {
        return moment(moment(), format);
    }

    public static getCurrentDateTimeISOString(format?: string) {
        return moment(moment(), format).toISOString();
    }

    private static convertToDateIfStringEndsWithZ(date: number | string | void | Date | moment.Moment | moment.MomentInputObject | (string | number)[] | undefined) {
        if (typeof date === "string" && date.endsWith('Z')) {
            return new Date(date);
        }

        return date;
    }
}